// extracted by mini-css-extract-plugin
module.exports = {"closeMenuIcon":"submenu-header_closeMenuIcon__RgWII","subTitle":"submenu-header_subTitle__SZL74"};